import {CommentsCategory} from '@domain/comments'
import {useUpmPlantContext} from '@hconnect/upm'
import {spawnErrorToast} from '@hm/fundamental'
import {keepPreviousData} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'
import {useErrorHandler} from 'react-error-boundary'

import {notifyIfErrorMessage} from '../../../common'
import {ErrorResponse, Comment} from '../../../interfaces/api'
import {usePlannerQuery} from '../usePlannerQuery'

export const useScheduleCommentsByScheduleItemId = (
  scheduleItemsIds: string[],
  isDisabled = false
) => {
  const raiseError = useErrorHandler()
  const {plantId: plantCode} = useUpmPlantContext()

  const query = usePlannerQuery(
    'comments',
    [
      {
        plantCode,
        commentsCategory: CommentsCategory.AssetOperationTimes,
        commentsCategoryInstanceIds: scheduleItemsIds
      }
    ],
    {
      select: (comments) =>
        comments.reduce(
          (acc, current) => {
            // NOTE: only one comment is possible per schedule item
            acc[current.commentsCategoryInstanceId] = current
            return acc
          },
          {} as Record<string, Comment>
        ),
      placeholderData: keepPreviousData,
      enabled: scheduleItemsIds.length > 0 && !isDisabled
    }
  )
  useEffect(() => {
    if (query.isError) {
      notifyIfErrorMessage(
        (query.error as AxiosError<ErrorResponse>)?.response?.data.detail,
        raiseError,
        spawnErrorToast
      )
    }
  }, [query.error, query.isError, raiseError])
  return query
}
